function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSubtitlesFill = function SvgSubtitlesFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff5c7f"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 1a4 4 0 0 0-4 4v14a4 4 0 0 0 4 4h14a4 4 0 0 0 4-4V5a4 4 0 0 0-4-4H5Zm1.8 11.208C6.8 10.841 7.846 9.8 9.055 9.8c.499 0 .961.172 1.338.47a.8.8 0 1 0 .991-1.256A3.748 3.748 0 0 0 9.055 8.2C6.89 8.2 5.2 10.032 5.2 12.208c0 2.177 1.69 4.009 3.855 4.009.878 0 1.685-.306 2.329-.814a.8.8 0 1 0-.99-1.256c-.378.298-.84.47-1.339.47-1.209 0-2.255-1.041-2.255-2.409Zm7.944 0c0-1.367 1.047-2.408 2.256-2.408.498 0 .96.172 1.338.47a.8.8 0 1 0 .99-1.256A3.748 3.748 0 0 0 17 8.2c-2.166 0-3.856 1.832-3.856 4.008 0 2.177 1.69 4.009 3.856 4.009.877 0 1.684-.306 2.328-.814a.8.8 0 0 0-.99-1.256c-.378.298-.84.47-1.338.47-1.21 0-2.256-1.041-2.256-2.409Z",
    fill: "#FF5C7F"
  }));
};
export default SvgSubtitlesFill;